import { ICommand } from 'core-ts-types';
import { TodoDateRangeService, TodosContentService } from 'capability-ng-todos';

export class MyTodosController {
  filterBy: string;
  private viewTitle: string;
  constructor(
    private $state: ng.ui.IStateService,
    private $scope: ng.IScope,
    private TodoFilterEnum: any,
    private ngTodoDateRangeService: TodoDateRangeService,
    private loadAllPathStatusCommand: ICommand,
    private loadAllReminderDateRangeCommand: ICommand,
    private ngTodosContentService: TodosContentService
  ) {
    const filterBy = $state.params.filterBy || 'all';
    const activeFilter = _.find(TodoFilterEnum.__keys__, (filter: any) => filter.stateParam === filterBy);
    ngTodosContentService.initialize(activeFilter);
    this.viewTitle = activeFilter === TodoFilterEnum.ALL_TODO_AND_EVENT ? 'To-Dos and Events' : activeFilter.name;
  }
}



// WEBPACK FOOTER //
// ./app/lib/my_todos/views/my_todos/my_todos_controller.ts